export const modules = {
  IELTS: [
    "Test fee",
    "OSR",
    "Extra TRF",
    "Transfer",
    "EOR",
    "Refund",
    "Mock IELTS",
  ],
  TKT: ["TKT Module 1", "TKT Module 2", "TKT Module 3", "Extra TRF", "Refund"],
  Linguaskill: [
    "Listening and Reading, Writing, Speaking",
    "Extra TRF",
    "Refund",
  ],
  Celta: ["Teacher Training", "DELTA Module 1", "FED EX", "CELTA TP", "Refund"],
  CEQs: [
    "Pre-A1 Starters (YLE Starters)",
    "A1 Movers (YLE Movers)",
    "A2 Flyers (YLE Flyers)",
    "A2 Key (KET)",
    "B1 Preliminary (PET)",
    "B2 First (FCE)",
    "C1 Advanced (CAE)",
    "C2 Proficiency (CPE)",
  ],
};
